// https://www.robinwieruch.de/react-router-private-routes/
import { Navigate, useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { useState, useEffect } from 'react';
import checkAuthOnLoad from '../features/checkAuth';

export default function AuthRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setUser(user);
      setLoading(false);
    });
  });

  useEffect(() => {
    window.checkAuthStatus = checkAuthOnLoad(setLoading, navigate, setUser);
  }, [navigate]);

  return loading ? <></> : user ? <Navigate to="/projects" replace /> : children;
}
